export const getClassifyDescribeAllTagsEndpoint = (classify) => `Classify/${classify}:describeAllTags`;
